const Privacy = () => (
  <div className="container-px mx-auto max-w-[800px] py-16 sm:py-24" data-testid="privacy-page">
    <p className="overline text-muted-foreground mb-3">Last updated: January 2026</p>
    <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Privacy Policy</h1>
    <div className="mt-10 space-y-8 text-base leading-relaxed">
      <section>
        <h2 className="font-display text-2xl font-bold mb-3">Introduction</h2>
        <p className="text-muted-foreground">EzHome ("we", "us") respects your privacy. This policy explains what information we collect, how we use it, and your rights.</p>
      </section>
      <section>
        <h2 className="font-display text-2xl font-bold mb-3">Information we collect</h2>
        <p className="text-muted-foreground">When you visit EzHome, we may collect your email (if subscribed), browser type, IP address, and pages viewed. We also track which affiliate links you click for analytics — this is anonymous.</p>
      </section>
      <section>
        <h2 className="font-display text-2xl font-bold mb-3">How we use it</h2>
        <p className="text-muted-foreground">To send you curated finds, improve our site, comply with legal obligations, and (with your consent) personalize your experience. We never sell your data.</p>
      </section>
      <section>
        <h2 className="font-display text-2xl font-bold mb-3">Cookies</h2>
        <p className="text-muted-foreground">We use first-party cookies for site functionality and third-party cookies (Amazon, AliExpress, SHEIN) for affiliate attribution. You can disable these in your browser.</p>
      </section>
      <section>
        <h2 className="font-display text-2xl font-bold mb-3">Your rights</h2>
        <p className="text-muted-foreground">You can request access, correction, or deletion of your data anytime by emailing privacy@ezhome.shop.</p>
      </section>
    </div>
  </div>
);

export default Privacy;
